import { useEffect, useState } from "react";
import { Auth, Hub } from "aws-amplify";

export function useAuthReady() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let mounted = true;

    const updateReady = async (valueIfOk) => {
      if (!mounted) return;
      setReady(valueIfOk);
    };

    const checkUser = async () => {
      try {
        await Auth.currentAuthenticatedUser();
        await updateReady(true);
      } catch {
        await updateReady(false);
      }
    };

    // initial auth check
    void checkUser();

    const unsubscribe = Hub.listen("auth", async (capsule) => {
      const evt = capsule?.payload?.event;

      if (evt === "signIn" || evt === "cognitoHostedUI") {
        await checkUser();
        return;
      }

      if (evt === "signOut") {
        if (mounted) setReady(false);
      }
    });

    return () => {
      mounted = false;
      unsubscribe();
    };
  }, []);

  return ready;
}